export const formatTime = (seconds) => {
    const pad = (num, size) => ("000" + num).slice(size * -1);
    const time = parseFloat(seconds).toFixed(3);
    const hours = Math.floor(time / 60 / 60);
    const minutes = Math.floor(time / 60) % 60;
    const secondsRemaining = Math.floor(time - minutes * 60);
    return `${hours ? pad(hours, 2) + ':' : ''}${pad(minutes, 2)}:${pad(secondsRemaining, 2)}`;
  };

  
  export const formatDuration = (durationInSeconds) => {
    if (durationInSeconds < 60) {
      // For durations under 1 minute, show only seconds
      return `${Math.floor(durationInSeconds)} seconds`;
    } else {
      // For durations 1 minute or longer, show HH:MM:SS
      const pad = (num) => (num < 10 ? "0" + num : num); // Pad single digits
      const hours = Math.floor(durationInSeconds / 3600);
      const minutes = Math.floor((durationInSeconds % 3600) / 60);
      const seconds = Math.floor(durationInSeconds % 60);
  
      return `${hours > 0 ? pad(hours) + ":" : ""}${pad(minutes)}:${pad(seconds)}`;
    }
  };
  
  export function toMinutes(hhmm) {
       const [hh, mm] = hhmm.split(":").map(Number);
       return hh * 60 + mm;
     }

     export function convert12To24WithSeconds(time12h) {
      const [time, modifier] = time12h.split(' ');
      let [hours, minutes] = time.split(':');
      if (hours === '12') hours = '00';
      if (modifier === 'PM') hours = String(parseInt(hours, 10) + 12).padStart(2, '0');
      return `${hours.padStart(2, '0')}:${minutes.padStart(2, '0')}:00`;
    }